import {Yup, TRANSLATION} from '@/imports-files/components/model/rejection-modal';

export const CONSTANTS = {
                            texts:{},
                            initialValue:{job_approval_users :{
                                                                  rejected_reason: ""
                                                                }
                                          }
                        }
export const REJECTION_MODAL_SCHEMA = (t) => Yup.object({
                              job_approval_users: Yup.object({
                                    rejected_reason: Yup.string().required(t('errors:required'))})
    })